import { compose, withHandlers } from 'recompose';
import { get, omit, pick, set } from 'lodash';
import {
  assignShopServiceToBarbers,
  saveShopOwnAssignment,
  saveBrandShopAssignment,
  saveShopBarberAssignment,
  unAssignShopAssignment,
} from '../../actions';
import { convertAssignmentsIntoObject } from '../../utils';
import withActiveUserIdAndType from '../../../../common/hoc/withActiveUserIdAndType';

const withServicesDataManagement = compose(
  withActiveUserIdAndType(),
  withHandlers({
    saveBarbersAssignments: props => async (shopId, barbersIds) => {
      const barbersAssignments = pick(get(props.serviceAssignments, [shopId, 'assignments']), barbersIds);
      barbersIds.forEach((barberId) => {
        barbersAssignments[barberId] = barbersAssignments[barberId] || {};
      });

      props.setServiceAssignments(
        set(props.serviceAssignments, [shopId, 'assignments'], barbersAssignments)
      );
      const shopAssignments = await assignShopServiceToBarbers(shopId, props.service.id, barbersIds);
      return convertAssignmentsIntoObject(shopAssignments);
    },
    saveShopAssignment: props => async (shopId, data = {}) => {
      const existedShopAssignment = props.serviceAssignments[shopId] || {};
      props.setServiceAssignments({
        ...props.serviceAssignments,
        [shopId]: {
          ...existedShopAssignment,
          ...data,
        },
      });

      if (props.activeType === 'shop') {
        return saveShopOwnAssignment(shopId, props.service.id, { ...data, id: shopId });
      }

      return saveBrandShopAssignment(props.brandId, props.service.id, { ...data, id: shopId });
    },
    saveBarberAssignment: props => async (shopId, barberId, data = {}) => {
      props.setServiceAssignments(
        set(props.serviceAssignments, [shopId, 'assignments', barberId], data)
      );
      return saveShopBarberAssignment(shopId, props.service.id, { ...data, id: barberId });
    },
    removeShopAssignment: props => async (id) => {
      props.setServiceAssignments(omit(props.serviceAssignments, [id]));
      return unAssignShopAssignment(id, props.service.id);
    },
  }),
);

export default withServicesDataManagement;
